import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { getTwoLetterCountryCode } from "../consts/THREE_TO_TWO_LETTER_COUNTRY_ISO_CODE";
import { getTwoLetterLanguageCode } from "../consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { isNotUndefined } from "../typescriptUtils";
var getLanguageCode = function(localeKey) {
    var languageCode = getTwoLetterLanguageCode(localeKey.language);
    if (languageCode === getTwoLetterLanguageCode(Language.GIBBERISH) || languageCode === getTwoLetterLanguageCode(Language.STRING_ID)) {
        return getTwoLetterLanguageCode(Language.ENG).toLowerCase();
    }
    return languageCode === null || languageCode === void 0 ? void 0 : languageCode.toLowerCase();
};
/**
 * Builds into locale language standard format i.e. en-US fr-FR de-DE
 * If for some reason language isn't returned, we should fail hard
 */ export var buildLocale = function(localeKey) {
    var _getTwoLetterCountryCode;
    var languageCode = getLanguageCode(localeKey);
    var countryCode = localeKey.country ? (_getTwoLetterCountryCode = getTwoLetterCountryCode(localeKey.country)) === null || _getTwoLetterCountryCode === void 0 ? void 0 : _getTwoLetterCountryCode.toUpperCase() : undefined;
    if (!languageCode) {
        throw new Error("Failed to map ".concat(localeKey.language, " to locale"));
    }
    return [
        languageCode,
        countryCode
    ].filter(isNotUndefined).join("-");
};
/**
 * Returns two letter language code from locale string constructed using buildLocale
 * @param locale locale string from buildLocale or window.navigator.languages
 */ export var languageFromLocaleString = function(locale) {
    var _locale_split_;
    return (_locale_split_ = locale.split("-")[0]) !== null && _locale_split_ !== void 0 ? _locale_split_ : "";
};
var getPdfLink = function(isPdf, link) {
    return isPdf ? "https://docs.google.com/gview?embedded=true&url=".concat(link) : link;
};
export var getLanguageAndCountrySpecificLink = function(args) {
    var _linksForLanguage_find, _defaultLink_restrictedCountries;
    var linkByLanguage = args.linkByLanguage, country = args.country, region = args.region, language = args.language, _args_isPdf = args.isPdf, isPdf = _args_isPdf === void 0 ? true : _args_isPdf;
    // If we do not have a link collection for the given language, return
    var linksForLanguage = linkByLanguage[language];
    if (!linksForLanguage) {
        return undefined;
    }
    // We search for a country specific link first
    var linkForCountry = (_linksForLanguage_find = linksForLanguage.find(function(l) {
        var _l_countries;
        return (_l_countries = l.countries) === null || _l_countries === void 0 ? void 0 : _l_countries.includes(country);
    })) === null || _linksForLanguage_find === void 0 ? void 0 : _linksForLanguage_find.link;
    if (linkForCountry) {
        return getPdfLink(isPdf, linkForCountry);
    }
    // If there is no country specific link, look for one for the region
    if (region) {
        var _linksForLanguage_find1;
        var linkForRegion = (_linksForLanguage_find1 = linksForLanguage.find(function(l) {
            var _l_restrictedCountries;
            return l.region === region && !((_l_restrictedCountries = l.restrictedCountries) === null || _l_restrictedCountries === void 0 ? void 0 : _l_restrictedCountries.includes(country));
        })) === null || _linksForLanguage_find1 === void 0 ? void 0 : _linksForLanguage_find1.link;
        if (linkForRegion) {
            return getPdfLink(isPdf, linkForRegion);
        }
    }
    // If there is no region specific link, look to see if there is one without any restrictions
    var defaultLink = linksForLanguage.find(function(l) {
        var _l_countries;
        return !l.region && !((_l_countries = l.countries) === null || _l_countries === void 0 ? void 0 : _l_countries.length);
    });
    if (defaultLink && !((_defaultLink_restrictedCountries = defaultLink.restrictedCountries) === null || _defaultLink_restrictedCountries === void 0 ? void 0 : _defaultLink_restrictedCountries.includes(country))) {
        return getPdfLink(isPdf, defaultLink === null || defaultLink === void 0 ? void 0 : defaultLink.link);
    }
    // Otherwise there are no links available for this user
    return undefined;
};
